function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  clipRule: "evenodd",
  d: "M16.093 8.331a1 1 0 011.487 1.338l-4.705 5.256a1 1 0 01-1.487 0L6.757 9.669a1 1 0 111.486-1.338l3.889 4.43 3.961-4.43z"
});

var SvgArrowDownSmall = function SvgArrowDownSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    fill: "none"
  }), _ref);
};

export default SvgArrowDownSmall;